module.exports = __webpack_public_path__ + "ss.svg?617f56e81e0c15b446d266b08ab2fd6a";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ss.svg
// module id = 941
// module chunks = 27